import { useEffect, useRef, useState } from 'react'
import ConfirmCodeDialog from './ConfirmCodeDialog'
import { registerConfirmHost } from './confirmCode'

/**
 * VH-285 — the one place the "enter your code" dialog is rendered. It sits in
 * the layout; `withConfirmation` anywhere in the app opens it.
 */
export default function ConfirmCodeHost() {
  const [open, setOpen] = useState(false)
  const waiting = useRef(null)

  useEffect(() => {
    const unregister = registerConfirmHost((resolve) => {
      // A second question while one is open: the first stays unconfirmed.
      waiting.current?.(false)
      waiting.current = resolve
      setOpen(true)
    })
    return () => {
      unregister()
      waiting.current?.(false)
      waiting.current = null
    }
  }, [])

  const answer = (confirmed) => {
    waiting.current?.(confirmed)
    waiting.current = null
    setOpen(false)
  }

  return (
    <ConfirmCodeDialog open={open} onConfirmed={() => answer(true)} onCancel={() => answer(false)} />
  )
}
